import styled from "@emotion/styled";
import {InfoRounded} from "@mui/icons-material";
import {IconButton} from "@mui/material";
import logo from "assets/img/logo.svg";
import {Bindings} from "data/constants/bindings";
import {useViewController} from "data/services/locator";
import {observer} from "mobx-react";
import React from "react";
import {useLocation} from "react-router";
import {NavLink} from "react-router-dom";
import {DrawerComponent} from "views/components/header/drawer.component";
import {IHeaderController} from "views/components/header/header.controller";

const Wrapper = styled.div`
	padding: 10px 12px;
	color: #ffffff;
	display: flex;
	justify-content: space-between;

	a {
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

export const Header: React.FC = observer(() => {
	const location = useLocation();
	const isLanding = location.pathname === "/";
	const {showModal, toggleMenu, menuState, routes} = useViewController<IHeaderController>(
		Bindings.HeaderController
	);

	if (isLanding) {
		return null;
	}

	return (
		<Wrapper>
			<IconButton
				onClick={showModal}
				color={"inherit"}
				aria-label={"Show tutorial modal"}
				role={"dialog"}>
				<InfoRounded color={"inherit"} />
			</IconButton>
			<NavLink to={"/"}>
				<img src={logo} alt="Header Logo" />
			</NavLink>
			<DrawerComponent toggleMenu={toggleMenu} menuState={menuState} routes={routes} />
		</Wrapper>
	);
});
